import { useMemo } from 'react';
import { useObjectExtraFields } from '../../../components/ExtraFields/useObjectExtraFields';
import {
  ExtraFieldsSupportedObject,
  ExtraFieldsTableId,
} from '../../../components/ExtraFields/types';
import { ExtraFieldColumnDef } from '../../../components/TimeSheetsTable/CustomizeTableColumns/types';

// Time-entry extra fields configured (via flair__Extra_Table_Field__mdt) to show
// as columns in the manager time-tracking controlling table. Hidden by default so
// they only appear once a manager enables them in "Customize columns".
export const useTimeEntryControllingExtraColumns = () => {
  const { getTableFields, loading } = useObjectExtraFields(
    ExtraFieldsSupportedObject.TimeEntry,
  );

  const extraColumns: ExtraFieldColumnDef[] = useMemo(
    () =>
      getTableFields(ExtraFieldsTableId.TimeEntryControllingManager).map(
        (field) => ({
          id: field.fieldApiName,
          title:
            field.columnTitle ?? field.fieldInfo?.label ?? field.fieldApiName,
          defaultChecked: false,
        }),
      ),
    [getTableFields],
  );

  return { extraColumns, loading };
};
